/**
 * Generates a data URI of a custom placeholder rectangle
 * @param {number} w - Width
 * @param {number} h - Height
 * @param {string} [color='#fafafa'] - Background color of the placeholder image.
 * Default: $color__alabaster
 * @returns {string} data URI
 */
function generatePlaceholderDataUri(w = 2, h = 3, color = '#fafafa') {
  const placeholderSvg = `<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 ${w} ${h}'><rect width='${w}' height='${h}' fill='${color}'/></svg>`;
  return `data:image/svg+xml,${encodeURIComponent(placeholderSvg)}`;
}

module.exports = {
  generatePlaceholderDataUri,
};
